import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'demand-by-supply-component',
  templateUrl: './demand-by-supply.component.html',
  styleUrls: ['./demand-by-supply.component.scss']
})
export class DemandBySupplyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
